module.exports = __webpack_public_path__ + "1926f41f5ea1c25d5924833448c62f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/footer/prohelvetia_large.png
// module id = 863
// module chunks = 0